import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import AddCashFormStyle from './css/AddCashFormStyle'

function AddCashForm(props) {
  const { payments, addPayments } = props
  const [cash, setCash] = useState('')
  const cashInputRef = useRef(null)

  const addCashPayment = () => {
    addPayments({
      name: 'Cash',
      total: (isNaN(cash) || (!cash)) ? 0.00 : cash,
    })
  }

  const onClick = (e) => {
    if (e.target.id === 'apply-btn') addCashPayment()
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      addCashPayment()
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }
    if (e.key === 'Escape') {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }
  }

  useEffect(() => {
    if (payments) {
      const foundCash = payments.find(payment => payment.name === 'Cash')
      if (foundCash) setCash(foundCash.total)
    }
    cashInputRef.current.focus()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      <div id='add-cash-form-container'>
        <div className='add-cash-input-wrapper'>
          <div id='add-cash-input-container'>
            <div id='add-cash-input-label' style={{textAlign: 'center', marginBottom: '5px'}}>Cash Amount</div>
            <input
              className='top-anchor'
              ref={cashInputRef}
              id='add-cash-input'
              value={cash}
              onKeyUp={onKeyUp}
              onChange={(e) => (e.target.value) ? setCash(parseFloat(e.target.value)) : setCash('')}
              type='number'
              min='0'
            />
          </div>
        </div>
        <div id='action-button-container'>
          <button
            id='cancel-btn'
            onClick={onClick}
            className='pospro-action-btn'>Cancel</button>
          <button
            id='apply-btn'
            onClick={onClick}
            className='pospro-action-btn bottom-anchor'>
            Apply
          </button>
        </div>
      </div>
      <AddCashFormStyle />
    </React.Fragment>
  )
}

export default React.memo(AddCashForm)
